/**
 * Copyright © 2026 Rémi Pace.
 * This file is part of Abc-Map.
 *
 * Abc-Map is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of
 * the License, or (at your option) any later version.
 *
 * Abc-Map is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General
 * Public License along with Abc-Map. If not, see <https://www.gnu.org/licenses/>.
 */

import { FillPatterns } from '@abc-map/shared';
import { IconName } from '@abc-map/point-icons';

export interface MapState {
  /**
   * Current style to apply
   */
  currentStyle: {
    fill: {
      color1: string;
      color2: string;
      pattern: FillPatterns;
    };
    stroke: {
      color: string;
      width: number;
    };
    text: {
      color: string;
      font: string;
      size: number;
      offsetX: number;
      offsetY: number;
      rotation: number;
    };
    point: {
      icon: string;
      size: number;
      color: string;
    };
  };
  geolocation: {
    enabled: boolean;
    followPosition: boolean;
    rotateMap: boolean;
  };
}

export const mapInitialState: MapState = {
  currentStyle: {
    fill: {
      color1: 'rgba(18,90,147,0.30)',
      color2: 'rgba(255,255,255,0.60)',
      pattern: FillPatterns.HatchingObliqueRight,
    },
    stroke: {
      color: 'rgba(18,90,147,0.60)',
      width: 3,
    },
    text: {
      color: 'rgba(18,90,147,1)',
      font: 'AbcCantarell',
      size: 15,
      offsetX: 20,
      offsetY: 20,
      rotation: 0,
    },
    point: {
      icon: IconName.IconGeoAltFill,
      size: 30,
      color: 'rgba(18,90,147,0.9)',
    },
  },
  geolocation: {
    enabled: false,
    followPosition: false,
    rotateMap: false,
  },
};
